export class PaymentReceiptModel {

    PaymentDate: string;
    PaymentAmount: string;
    // Only set when a credit card surcharge was charged; PaymentAmount is then the card total.
    BaseAmount?: string;
    SurchargeAmount?: string;
    PaymentReference: string;
    PaymentDescription: string;
    PaymentAccount: string;
    PracticeName: string;
    PracticeAddress: string;
    PracticeAddress2: string;
    PracticePhone: string;
    PatientName: string;
    CardHolderName: string;
    InvoiceNumber: string;    
    PaymentTypeId: string;

    constructor() {
        this.PaymentDate = '';
        this.PaymentAmount = '';
        this.PaymentReference = '';
        this.PaymentDescription = '';
        this.PaymentAccount = '';
        this.PracticeName = '';
        this.PracticeAddress = '';
        this.PracticeAddress2 = '';
        this.PracticePhone = '';
        this.PatientName = '';
        this.CardHolderName = '';
        this.InvoiceNumber = '';
        this.PaymentTypeId = '';
    }
}
